'use strict';

/* Services */

angular.module('Syrinscape.services', [])

	.value('version', '0.1')

	.factory('$global_state', function($http) {
		return $http.get(context.urls.GLOBAL_STATE);
	})

	.factory('$categories', function($http) {
		return $http.get(context.urls.API_CATEGORIES_LIST);
	})

	.factory('$subcategories', function($http) {
		return $http.get(context.urls.API_SUBCATEGORIES_LIST);
	})

	.factory('$reverb_presets', function($http) {
		return $http.get(context.urls.API_REVERB_PRESETS).success(
			function(data, status, headers, config) {
				data.delete = function(item) {
					$http.delete(item.url).success(function() {
						var index=data.indexOf(item);
						data.splice(index,1);
					});
				};

				data.from_url = function(url) {
					return _.find(this, { url: url });
				};

				return data;
			}
		);
	})

	.factory('unity_ids', function(BaseModel) {
		var registry = {};
		return {
			_getRegistery: function() {
				return registry
			},
			get: function(id) {
				return registry[id];
			},
			has: function(id) {
				return registry[id] !== undefined;
			},
			set: function(id, obj) {
				if (this.has(id)) {
					console.warn(
						'Overridding unity id "' + id + '".',
						'\nCurrently', unity_ids[id],
						'\nChanging to', obj
					);
				}
				return registry[id] = obj;
			},
			update: function(obj) {
				// Update by passing the instance back through
				// the BaseModel constructor
				var instance = registry[obj.unity_id];
				BaseModel.call(instance, obj);
				return instance;
			},
			createOrUpdate: function(model, obj, arg) {
				var instance;
				if (obj.unity_id && registry[obj.unity_id] !== undefined) {
					instance = this.update(obj);
				} else {
					// Create a new instance and add it the registry
					instance = new model(obj, arg);
					if (instance.unity_id) {
						registry[instance.unity_id] = instance;
					}
				}
				return instance;
			}
		}
	})

	.factory('BaseModel', function() {
		return function BaseModel(data) {
			var self = this;
			_.forOwn(data, function(value, prop) {
				// Ignore Angular's props
				if (prop[0] !== '$') {
					self[prop] = value;
				}
			}, this);
		};
	})

	.factory('Playlist', function(BaseModel) {
		return function Playlist(data) {
			BaseModel.call(this, data);

			this.amplitude = 0;
		};
	})

	.factory('Sample', function(BaseModel) {
		return function Sample(data) {
			BaseModel.call(this, data);

			this.amplitude = 0;
		};
	})

	.factory('queryable_instances_factory', function($http, unity_ids) {
		return function(Model, instance_endpoint, query_endpoint) {
			var instances = [];

			instances.addInstances =  function(data) {
				data.forEach(function(obj) {
					var instance = new Model(obj);
					instances.push(instance);
				});
			};

			instances.fetch_by_id = function(ids) {
				var url = instance_endpoint;
				var post_data = { 'id:in': ids };
				return $http.post(url, post_data).then(function(data) {
					instances.addInstances(data.data);
				});
			};

			instances.fetch_by_query = function(fields, query) {
				return $http.get(query_endpoint + '?' + fields + ':icontains=' + query).then(function(data) {
					var matched_instances = data.data;

					var get_matched_instances = function() {
						var matched_unity_ids = _.map(matched_instances, 'unity_id');
						return _.filter(instances, function(instance) {
							return _.includes(matched_unity_ids, instance.unity_id);
						});
					};

					var matched_instances_to_fetch = _.filter(matched_instances, function(ids) {
						return !unity_ids[ids.unity_id];
					});
					var matched_ids_to_fetch = _.map(matched_instances_to_fetch, 'id');

					if (matched_ids_to_fetch.length) {
						return instances
							.fetch_by_id(matched_ids_to_fetch)
							.then(get_matched_instances);
					} else {
						return get_matched_instances();
					}
				});
			};

			return instances;
		};
	})

	.factory('attribution_selector_factory', function() {
		// General wiring and state management for sample attribution selectors.

		var CREATED_BY_UPLOADER_TYPE = '@@CREATED_BY_UPLOADER_TYPE';
		var CREATIVE_COMMONS_ZERO_TYPE = '@@CREATIVE_COMMONS_ZERO_TYPE';
		var CREATIVE_COMMONS_ATTRIBUTION_TYPE = '@@CREATIVE_COMMONS_ATTRIBUTION_TYPE';
		var SAMPLE_NAME_TYPE = '@@SAMPLE_NAME_TYPE';
		var SAMPLE_NAME_VALUE = '@@SAMPLE_NAME_VALUE';
		var OTHER_TYPE = '@@OTHER_TYPE';

		var _attribution_id = 0;

		function attribution_selector_factory(opts) {
			opts = opts || {};
			var initial_value = opts.initial_value || '';

			// Maintain a reference to the return value, so that we can patch values
			// without relying on angular calling a method
			var _ref;

			var CREATED_BY_UPLOADER_CHOICE = {
				type: CREATED_BY_UPLOADER_TYPE,
				label: 'Created by Uploader',
				initial_value: 'This sample was created by the uploader',
				allow_custom_value: false,
				validate: function() { return []; },
				validation_errors: [],
			};

			var CREATIVE_COMMONS_ZERO_CHOICE = {
				type: CREATIVE_COMMONS_ZERO_TYPE,
				label: 'Creative Commons: Zero',
				initial_value: 'This sample is used under Creative Commons: Zero licence',
				allow_custom_value: false,
				validate: function() { return []; },
				validation_errors: [],
			};

			var CREATIVE_COMMONS_ATTRIBUTION_CHOICE = {
				type: CREATIVE_COMMONS_ATTRIBUTION_TYPE,
				label: 'Creative Commons: Attribution',
				initial_value: 'This sample is used under Creative Commons Attribution Licence, sourced from sample ##### created by #####',
				allow_custom_value: true,
				validate: function(value) {
					var errors = [];
					if (!value.trim() || value === CREATIVE_COMMONS_ATTRIBUTION_CHOICE.initial_value) {
						errors.push('The attribution must be defined');
					}
					return errors;
				},
				validation_errors: [],
			};

			var SAMPLE_NAME_CHOICE = {
				type: SAMPLE_NAME_TYPE,
				label: 'Sample name',
				initial_value: SAMPLE_NAME_VALUE,
				allow_custom_value: false,
				validate: function() { return []; },
				validation_errors: [],
			};

			var OTHER_CHOICE = {
				type: OTHER_TYPE,
				label: 'Other',
				initial_value: '',
				allow_custom_value: true,
				validate: function(value) {
					var errors = [];
					if (!value.trim()) {
						errors.push('The attribution must be defined');
					}
					return errors;
				},
				validation_errors: [],
			};

			var choices = [
				CREATED_BY_UPLOADER_CHOICE,
				CREATIVE_COMMONS_ZERO_CHOICE,
				CREATIVE_COMMONS_ATTRIBUTION_CHOICE,
				SAMPLE_NAME_CHOICE,
				OTHER_CHOICE,
			];

			var custom_attribution_id = 'attribution-selector-custom-input-' + (++_attribution_id);

			// The exposed API
			_ref = {
				choices: choices,
				selected_type: null,
				select_type: select_type,
				custom_attribution_id: custom_attribution_id,
				get_value: get_value,
				validate: validate,
			};

			if (initial_value) {
				var initial_type;
				// Attempt to find a matching type and fall back to other
				if (initial_value.indexOf('This sample is used under Creative Commons Attribution Licence') === 0) {
					initial_type = get_type_object(CREATIVE_COMMONS_ATTRIBUTION_TYPE);
					initial_type.value = initial_value;
				} else {
					initial_type = _.find(choices, function(choice) {
						return choice.initial_value === initial_value;
					});
					if (!initial_type) {
						initial_type = get_type_object(OTHER_TYPE);
						initial_type.value = initial_value;
					}
				}
				select_type(initial_type.type);
			}

			function get_type_object(type) {
				return _.find(choices, {type: type});
			}

			function select_type(selected_type) {
				var type_obj = get_type_object(selected_type);
				if (!type_obj) throw new Error('Unknown type: ' + selected_type);

				// Is this type already the selected type?
				if (_ref.selected_type === type_obj) {
					_ref.selected_type = null;
				} else {
					_ref.selected_type = type_obj;
					if (type_obj.value === undefined) {
						type_obj.value = type_obj.initial_value;
					}

					if (type_obj.allow_custom_value) {
						setTimeout(function() {
							$('#' + custom_attribution_id).focus();
						}, 50);
					}
				}
			}

			function get_value() {
				if (_ref.selected_type) {
					return _ref.selected_type.value;
				}
				return '';
			}

			function validate() {
				if (_ref.selected_type) {
					_ref.selected_type.validation_errors = [];
					var errors = _ref.selected_type.validate(get_value());
					if (errors.length) {
						_ref.selected_type.validation_errors = errors;
						return false;
					}
				}
				return true;
			}

			return _ref;
		}

		return {
			CREATED_BY_UPLOADER_TYPE: CREATED_BY_UPLOADER_TYPE,
			CREATIVE_COMMONS_ZERO_TYPE: CREATIVE_COMMONS_ZERO_TYPE,
			CREATIVE_COMMONS_ATTRIBUTION_TYPE: CREATIVE_COMMONS_ATTRIBUTION_TYPE,
			SAMPLE_NAME_TYPE: SAMPLE_NAME_TYPE,
			OTHER_TYPE: OTHER_TYPE,
			create: attribution_selector_factory,
		}
	})

	.factory('Element', function(BaseModel, $http, Playlist, unity_ids) {
		var Element = function Element(data) {
			BaseModel.call(this, data);

			this.amplitude = 0;

			this.playlist = this.playlist.map(function(obj) {
				return unity_ids.createOrUpdate(Playlist, obj);
			});
		};

		Element.prototype = {
			delete_playlist_item: function(playlist_item) {
				var element = this;
				return $http.delete(playlist_item.url).success(function() {
					element.playlist = _.without(element.playlist, playlist_item);
				});
			},
			add_playlist_item: function(playlist_item,onAdd) {
				var element = this;
				var pli = {
					element: element.url,
					sample: playlist_item.url,
					min_gain: 1.0,
					max_gain: 1.0
				};
				$http.post(context.urls.API_PLAYLISTS, pli).success(function(data) {
					data = unity_ids.createOrUpdate(Playlist, data);
					element.playlist.push(data);
					if(onAdd)
						onAdd()
				});
			},
			is_positioned: function () {
				return this.element_type === 'sfx' || this.element_type === 'oneshot'
			},
			plays: function(mood) {
				if (!mood) {
					return false;
				}
				return _.some(mood.elements, {
					element: this.url,
					plays: true
				});
			},
			prepForSave: function() {
				if (this.crossfade_samples && !this.crossfade_duration) {
					this.crossfade_duration = 2;
				}
				if (this.is_positioned()) {
					if (this.min_angle === null) {
						this.min_angle = -180
					}
					if (this.max_angle === null) {
						this.max_angle = 180
					}
					if (this.min_distance === null) {
						this.min_distance = 0
					}
					if (this.max_distance === null) {
						this.max_distance = 10
					}
					if (this.speed === null) {
						this.speed = 0
					}
				}
				return this;
			}
		};

		return Element;
	})

	.factory('ModelFilter', function($timeout) {
		var ModelFilter = function ModelFilter(model) {
			this.model = model;
			this.query = '';
			this.objects = [];
			this.timeout_id = null;
			this.page = null;
			this.next_page = null;
			this.prev_page = null;
			this.loading = false;
			this.pending_request_id = null;
		};

		ModelFilter.prototype._fetch_by_query = function(opts) {
			var pending_request_id = {};
			this.pending_request_id = pending_request_id;
			this.loading = true;
			return this.model.fetch_by_query(this.query, opts.page)
				.then(_.bind(function(data) {
					// If another request had been sent while this was underway, we
					// ignore the result
					if (pending_request_id !== this.pending_request_id) {
						return;
					}

					this.page = data.page;
					this.next_page = data.next_page;
					this.prev_page = data.prev_page;
					if (opts.append) {
						this.objects = this.objects.concat(data.objects);
					} else {
						this.objects = data.objects;
					}
					this.loading = false;
				}, this))
				.catch(_.bind(function(err) {
					this.loading = false;
					throw err;
				}, this));
		};

		ModelFilter.prototype.fetch_query_results = function(opts) {
			opts = opts || {};

			if (this.timeout_id) {
				$timeout.cancel(this.timeout_id);
			}

			if (opts.immediate) {
				return this._fetch_by_query(opts);
			} else {
				var _this = this;
				return new Promise(function(resolve, reject) {
					_this.timeout_id = $timeout(
						function() {
							return _this._fetch_by_query(opts).then(resolve, reject);
						},
						250
					);
				});
			}
		};

		ModelFilter.prototype.get_next_page = function() {
			if (!this.loading && this.next_page) {
				return this.fetch_query_results({
					page: this.next_page,
					immediate: true,
					append: true
				});
			}
		};

		ModelFilter.prototype.refresh = function() {
			if (this.query) {
				return this.fetch_query_results();
			}
			return Promise.resolve(null);
		};

		return ModelFilter;
	})

	.factory('FilterableModel', function($http, unity_ids, ModelFilter) {
		var FilterableModel = function FilterableModel(opts) {
			this.opts = opts;
			this.objects = [];
			this.filtered = new ModelFilter(this);
			this._pending_request = null;
		};

		FilterableModel.prototype.create = function(obj) {
			var instance = unity_ids.createOrUpdate(this.opts.model, obj);
			if (!_.includes(this.objects, instance)) {
				this.objects.push(instance);
			}
			return instance;
		};

		FilterableModel.prototype.fetch_by_id = function(ids) {
			var url = this.opts.endpoints.instance;
			var post_data = { 'id:in': ids };
			return $http.post(url, post_data)
				.then(_.bind(function(data) {
					data.data.map(this.create, this);
				}, this));
		};

		FilterableModel.prototype._get_matched_objects = function(data, page) {
			var matched_unity_ids = _.map(data.results, 'unity_id');
			return {
				objects: _.filter(this.objects, function(instance) {
					return _.includes(matched_unity_ids, instance.unity_id);
				}),
				page: page,
				next_page: data.next ? page + 1 : null,
				prev_page: data.previous ? page - 1 : null
			}
		};

		FilterableModel.prototype.fetch_by_query = function(query, page) {
			// Prevent empty queries from hammering the server
			if (!query) {
				return Promise.resolve(
					this._get_matched_objects({results: []})
				);
			}

			page = page || 1;
			var params = ['page=' + page];
			if (query) {
				params.push(
					this.opts.query_fields.join(':') + ':icontains=' + encodeURIComponent(query)
				);
			}
			var url = this.opts.endpoints.query + '?' + params.join('&');

			return $http.get(url)
				.then(_.bind(function(data) {
					data = data.data;
					var matches = data.results;

					var matches_to_fetch = _.filter(matches, function(ids) {
						return !unity_ids[ids.unity_id];
					});

					if (!matches_to_fetch.length) {
						return this._get_matched_objects(data, page);
					}

					var ids = _.map(matches_to_fetch, 'id');
					return this.fetch_by_id(ids)
						.then(_.bind(function() {
							return this._get_matched_objects(data, page);
						}, this));
				}, this));
		};

		return FilterableModel;
	})

	.factory('samples', function($http, Sample, FilterableModel) {
		var samples = new FilterableModel({
			model: Sample,
			endpoints: {
				instance: context.urls.API_SAMPLE_FILTER,
				query: context.urls.API_SAMPLE_IDS_BY_QUERY
			},
			query_fields: ['title']
		});

		samples.delete_sample = function(sample) {
			return $http.delete(sample.url).success(function() {
				_.pull(samples.objects, sample);
			});
		};

		return samples;
	})

	.factory('elements', function($http, Element, FilterableModel) {
		return new FilterableModel({
			model: Element,
			endpoints: {
				instance: context.urls.API_ELEMENT_FILTER,
				query: context.urls.API_ELEMENT_IDS_BY_QUERY
			},
			query_fields: ['title']
		});
 	})

	.factory('Mood', function(BaseModel, $http) {
		var Mood = function Mood(data, soundset) {
			BaseModel.call(this, data);

			var mood = this;
			this.bindElementObjects = function() {
				// Element objects from the mood's soundset
				var elementUrls = _.map(mood.elements, 'element');
				mood.element_objects = _.filter(soundset.elements, function(element) {
					return _.includes(elementUrls, element.url);
				});
			};

			this.bindElementObjects();
		};

		Mood.prototype = {
			contains_element: function(element) {
				if (!element || !element.url) {
					return false;
				}
				return _.includes(_.map(this.elements, 'element'), element.url);
			}
		};

		return Mood;
	})

	.factory('Soundset', function(BaseModel, unity_ids, $http, $q, Mood, elements, samples) {
		var Soundset = function Soundset(data) {
			BaseModel.call(this, data);

			this._has_fetched_detail = false;
			this._has_fetched_moods = false;
			this._has_fetched_elements = false;
		};

		Soundset.prototype = {
			prepForSave: function() {
				// The API expects arrays of PKs to be returned, rather
				// than the related objects
				var clone = _.cloneDeep(this);
				clone.moods = _.map(clone.moods, 'pk');
				clone.elements = _.map(clone.elements, 'pk');
				return clone;
			},
			re_fetch_related: function() {
				var soundset = this;
				soundset.clear_element_cache();
				soundset.clear_mood_cache();
				soundset.fetch_related();
			},
			fetch_related: function() {
				var soundset = this;
				return soundset.fetch_detail().then(function() {
					return $q.all([
						soundset.fetch_moods(),
						soundset.fetch_elements()
					]);
				});
			},
			fetch_detail: function() {
				var soundset = this;
				if (soundset._has_fetched_detail) {
					return $q.when(soundset);
				}
				return $http.get(soundset.url).then(function(data) {
					angular.extend(soundset, data.data);
					soundset._has_fetched_detail = true;
					return soundset;
				});
			},
			fetch_moods: function() {
				var soundset = this;
				if (soundset._has_fetched_moods) {
					return soundset.moods;
				}
				return soundset.re_fetch_moods();
			},
			re_fetch_moods: function() {
				var soundset = this;
				return $http.get(context.urls.API_MOODS + '?soundset__uuid=' + this.uuid).then(function(data) {
					var moods = data.data;
					soundset._has_fetched_moods = true;
					return soundset.moods = moods.map(function(obj) {
						return unity_ids.createOrUpdate(Mood, obj, soundset);
					});
				});
			},
			fetch_elements: function() {
				var soundset = this;
				if (soundset._has_fetched_elements) {
					return soundset.elements;
				}
				return soundset.re_fetch_elements();
			},
			re_fetch_elements: function() {
				var soundset = this;
				return $http.get(context.urls.API_ELEMENTS + '?soundset__uuid=' + this.uuid).then(function(data) {
					soundset.elements = data.data.map(elements.create, elements);
					soundset._has_fetched_elements = true;
					return soundset.elements;
				});
			},
			elements_from_url: function(url) {
				return _.find(this.elements, { url: url });
			},
			delete_element: function(element) {
				var soundset = this;
				return $http.delete(element.url).success(function () {
					var index = soundset.elements.indexOf(element);
					soundset.elements.splice(index, 1);
				});
			},
			duplicate_element: function(element) {
				var soundset = this;
				return $http.post(element.duplicate_url).success(function(data) {
					var duplicate = elements.create(data);
					var index = soundset.elements.indexOf(element) + 1;
					soundset.elements.splice(index, 0, duplicate);
				});
			},
			delete_mood: function(mood) {
				var soundset = this;
				return $http.delete(mood.url).success(function() {
					var index = soundset.moods.indexOf(mood);
					soundset.moods.splice(index, 1);
				});
			},
			clear_element_cache: function() {
				this._has_fetched_elements = false;
			},
			clear_mood_cache: function() {
				this._has_fetched_moods= false;
			}
		};

		return Soundset;
	})

	.factory('campaigns', function($http) {
		return {
			getCampaigns: function() {
				return $http.get(context.urls.API_CAMPAIGNS_LIST)
					.then(function(data) {
						return data.data;
					});
			}
		};
	})

	.factory('global_elements', function($http, Element, unity_ids) {
		return {
			getGlobalElements: function() {
				return $http.get(context.urls.API_GLOBAL_ELEMENTS)
					.then(function(data) {
						return data.data.map(function(obj) {
							return unity_ids.createOrUpdate(Element, obj);
						});
					});
			}
		}
	})

	.factory('response_errors', function($q) {
		var handlers = [];
		return {
			on_error: function(cb) {
				handlers.push(cb);
			},
			handle_$http_response: function(res) {
				var message = '';
				if (res.status === 500) {
					message = '<strong>Sorry, something went wrong.</strong> We have already been notified with more specific error details.';
				} else {
					// Permission errors should contain enough information to output the returned
					// warning as is. Other types, 500/404/etc are unlikely to include meaningful
					// content, so the status and text may be useful to the user
					if (res.status !== 403) {
						message += res.status + ' ' + res.statusText;
					}
					// Handle the various forms that the APIs errors can arrive in
					if (res.data && res.data.detail) {
						if (message) message += ' - ';
						message += res.data.detail;
					} else if (_.isString(res.data)) {
						if (message) message += ' - ';
						message += res.data;
					}
				}
				var error = {
					message: message,
					status_code: res.status,
					status_text: res.statusText,
				};
				_.forEach(handlers, function(cb) {
					cb(error);
				});
			},
		};
	})

	.factory('soundsets', function($http, Soundset, unity_ids) {
		let pending_request = null;
		return {
			getSoundsets: function(){
				if (pending_request !== null)
					return pending_request;

				pending_request = $http.get(context.urls.API_SOUNDSETS)
					.then(function(data) {
						var soundsets = data.data;

						soundsets = soundsets.map(function(obj) {
							return unity_ids.createOrUpdate(Soundset, obj);
						});

						soundsets.delete_soundset = function(soundset) {
							return $http.delete(soundset.url).success(function() {
								_.pull(soundsets, soundset);
							});
						};

						soundsets.duplicate_soundset = function(soundset) {
							return $http.post(soundset.duplicate_url).success(function(data) {
								var duplicate = unity_ids.createOrUpdate(Soundset, data);
								var index = soundsets.indexOf(soundset) + 1;
								soundsets.splice(index, 0, duplicate);
							});
						};

						soundsets.submit_for_publishing_approval = function(soundset) {
							return $http.post(soundset.submit_for_publishing_approval_url).success(function() {
								console.log("Successfully submitted for publishing approval")
							});
						};

						soundsets.retract_from_publishing_approval = function(soundset) {
							return $http.post(soundset.retract_from_publishing_approval_url).success(function() {
								console.log("Successfully retracted from publishing approval")
							});
						};

						soundsets.approve_soundset_as_community_content = function(soundset) {
							return $http.post(soundset.approve_soundset_as_community_content_url).success(function() {
								console.log("Successfully approved soundset as community content")
							});
						};

						soundsets.reject_soundset = function(soundset, on_success) {
							if (!soundset.rejected_reason) {
								// See `focus_animation()` in `controllers.js`.
								console.log("Cannot soundset reject without a reason.");
								angular.element('#rejected_reason').addClass('input__focus').focus().select();
								_.delay(function () {
									angular.element('#rejected_reason').removeClass('input__focus');
								}, 2000, 'later');
							} else {
								soundset.show_reject_confirm = false;
								return $http.post(soundset.reject_soundset_url, {"reason": soundset.rejected_reason}).success(function(data) {
									console.log("Successfully rejected soundset");
									on_success(data);
								});
							}
						};

						soundsets.dismiss_rejection = function(soundset) {
							return $http.post(soundset.dismiss_rejection_url).success(function() {
								console.log("Successfully dismissed rejection message for soundset")
							});
						};

						pending_request = null;
						return soundsets
					},
					(err) => {
						pending_request = null;
						console.error(`Request to "${context.urls.API_SOUNDSETS}" failed.`, err);
						throw err;
					}
				);

				return pending_request;
			}
		}
	})

	.factory('user', function() {
		// Deep-clone to prevent any unexpected mutations to our `user` object
		return _.cloneDeep(context.user);
	})

	.factory('utils', function() {
		return {
			convert_metres_to_feet: function(val) {
				return val * 3.28084;
			},
			convert_feet_to_metres: function(val) {
				return val / 3.28084;
			},
		};
	})

	.factory('$editor', ['$rootScope', '$http', function($rootScope, $http) {
		// Service to encapsulate access to the websocket api
		// so it can be used with more than one controller

		var TOKEN = context.API_TOKEN;
		var DEFAULT_BACKOFF = 500;  // 0.5 seconds - initial wait after connection failure
		var BACKOFF_MULTIPLIER = 2; // Double the back-off after every fail
		var BACKOFF_MAXIMUM = 1000 * 60 * 2; // 2 minutes - max time between connection attempts

		function spawnSocket(backoff) {
			if (backoff > BACKOFF_MAXIMUM) {
				backoff = BACKOFF_MAXIMUM;
			}

			var socket = new WebSocket(context.BACKEND.websocket_url);

			socket.onopen = function() {
				// Reset the backoff once we've connected successfully
				backoff = DEFAULT_BACKOFF;

				this.send(JSON.stringify({
					message: 'register',
					token: TOKEN,
				}));

				emit_msg('started', {});
			};

			socket.onmessage = function(message) {
				if (message.data) {
					var data = JSON.parse(message.data);
					// Reconnect. Handle this here instead of in `route_message()` for access to
					// `socket`.
					if (data['message'] == 'reconnect_to_new_backend') {
						context.BACKEND.subdomain = data.params.subdomain;
						context.BACKEND.domain_and_port =
							data.params.domain_and_port || context.BACKEND.domain_and_port;
						context.BACKEND.websocket_url = data.params.websocket_url;
						socket.close();
					// Route message.
					}
					route_message(data['message'], data['params']);
				}
			};

			socket.onclose = function() {
				setTimeout(function() {
					spawnSocket(backoff * BACKOFF_MULTIPLIER);
				}, backoff);
			};

			return socket;
		}

		spawnSocket(DEFAULT_BACKOFF);

		var is_connected = false;
		let is_mixed_connected = false;

		var msg_name = function(message) {
			return 'editor.' + message;
		};

		var emit_msg = function(message, params) {
			// emit the message
			$rootScope.$emit(msg_name(message), params);
		};

		var route_message = function(message, params) {
			// TODO Do we still need to receive and handle 'connected' and
			// 'disconnected' messages? If so, we need to re-implement so these
			// messages are only received from the frontend user's own device.

			switch (message) {
				case "multi":
					_.each(params, function(data) {
						var message = data['message'];
						var params = data['params'];
						route_message(message, params);
					});
					break;
				case "connected":
					is_connected = true;
					emit_msg(message, params);
					break;
				case "disconnected":
					is_connected = false;
					emit_msg(message, params);
					break;
				case "mixed_connected":
					is_mixed_connected = true;
					emit_msg(message, params);
					break;
				case "mixed_disconnected":
					is_mixed_connected = false;
					emit_msg(message, params);
					break;
				case "reconnect_to_new_backend":
					emit_msg(message, params);
					break;
				// NOTE: authorized is returned after a login *OR* get_key
				case "authorized":
					var is_authorized = params.is_authorized;
					if (is_authorized) {
						send_initial_config();
					}
					emit_msg(message, params);
					break;
				case "state":
					emit_msg(message, params);
					break;
				case "items_updated":
					emit_msg(message, params);
					break;
				case "categories_list":
					emit_msg(message, params);
					break;
				case "keep-alive": // Ignore `keep-alive` messages
					break;
				default:
					console.log('Unexpected message:', message);
			}
		};

		// general purpose message subscribe and auto-unsubscribe
		var on_msg = function(msg, func, scope) {
			var unbind = $rootScope.$on(msg_name(msg), func);
			if (scope) {
				scope.$on('$destroy', unbind);
			}
			return unbind;
		};

		// send the initial config to Unity
		var send_initial_config = function() {
			return $http.post(context.urls.SEND_INITIAL_CONFIG, {})
				.success(function(data) {
					// tell the world we are done loading
					// TODO: add message from Unity when actually completed
					// @rantecki says - "That's not entirely straight forward
					// actually as the preloading is asynchronous, and not all
					// the samples will end up being preloaded.
					// It's on my list of things to do."
					emit_msg('config_loaded', {});
				})
				.error(function(data) {
					console.log('Could not load initial config!');
				})
		};

		return {
			// are we connected to Unity or WebPlayer?
			is_connected: function() {
				return is_connected;
			},
			// does the session have both Unity and WebPlayer connections?
			is_mixed_connected: function() {
				return is_mixed_connected;
			},
			// notify when socket is started
			on_started: function(func, scope) {
				return on_msg('started', func, scope);
			},
			// notify when Unity or WebPlayer are connected
			on_connected: function(func, scope) {
				return on_msg('connected', func, scope);
			},
			// notify when Unity and WebPlayer are both connected in the session
			on_mixed_connected: function(func, scope) {
				return on_msg('mixed_connected', func, scope);
			},
			// apply scope to update server/reconnect tooltip
			on_reconnect_to_new_backend: function (func, scope) {
				return on_msg('reconnect_to_new_backend', func, scope);
			},
			// notify when Unity sends authorization message
			on_authorized: function(func, scope) {
				return on_msg('authorized', func, scope);
			},
			// notify when Unity sends state message
			on_state: function(func, scope) {
				return on_msg('state', func, scope);
			},
			// notify when the backend indicates that items need to be refreshed
			on_items_updated: function(func, scope) {
				return on_msg('items_updated', func, scope);
			},
			// notify when Unity or WebPlayer are disconnected
			on_disconnected: function(func, scope) {
				return on_msg('disconnected', func, scope);
			},
			// notify when there are no longer both Unity and WebPlayer in the session
			on_mixed_disconnected: function(func, scope) {
				return on_msg('mixed_disconnected', func, scope);
			},
			// notify when Unity config loaded
			on_config_loaded: function(func, scope) {
				return on_msg('config_loaded', func, scope);
			},
			on_categories_list: function(func, scope) {
				return on_msg('categories_list', func, scope);
			}
		}
	}])
;



// WEBPACK FOOTER //
// ./djangosite/master/frontend/src/services.js